<script setup lang="ts">
import { computed } from 'vue'
import { Icon } from '@iconify/vue'
import { numHelper } from '@/utils/numHelper.ts'

interface Props {
  data: object | string | number
  cellConfig: Object,
}

const props = defineProps<Props>()

</script>

<template>
<div class="table-cell contract-asset-cell">
  <template v-if="props.data?.id">
    <div class="code">{{props.data?.id}}</div>
    <div class="title">{{props.data?.title}}</div>
<!--  {{props.data?.real_estate?.address}}-->
<!--  {{props.data?.real_estate?.province_id}}-->
<!--  {{props.data?.real_estate?.district_id}}-->
<!--  {{props.data?.real_estate?.ward_id}}-->
<!--  {{props.data}}-->
  </template>
</div>
</template>

<style lang="scss">
.contract-asset-cell{
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 3px;

  word-break: keep-all;
  white-space: nowrap;

  .code{
    padding: 3px 5px;
    border-radius: 4px;
    background: #ffe0cb;
    color: #e15f00;
  }
  .title{
    font-weight: bold;
    font-size: .7rem;
    text-transform: capitalize;
  }
}
</style>
